import { useEffect, useState } from 'react';
import { requestFromPriceFromSite } from '@ff-os/pdp-shared-redux/global-state/site-pricing';

const TIMEOUT_MS = 10_000;

const withTimeout = <T>(promise: Promise<T>) => Promise.race([
    promise,
    new Promise<undefined>(resolve => setTimeout(() => resolve(undefined), TIMEOUT_MS))
]);

const toCents = (formatted: string): number | undefined => {
    const digits = formatted.replace(/\D/g, '');
    return digits.length >= 3 ? Number(digits) : undefined;
};

const readAmount = async (sku: string): Promise<number | undefined> => {

    const content = await withTimeout(requestFromPriceFromSite({ sku })).catch(() => undefined);

    return typeof content === 'string' ? toCents(content) : undefined;
};

export const useExternalAmounts = (skus: readonly string[]) => {

    const [amounts, setAmounts] = useState<Record<string, number>>();

    const key = skus.join(' ');

    useEffect(() => {

        let cancelled = false;

        setAmounts(undefined);

        Promise
            .all(skus.map(sku => readAmount(sku)))
            .then(read => {
                if (!cancelled) {
                    setAmounts(Object.fromEntries(read
                        .map((cents, i) => [skus[i], cents] as const)
                        .filter((entry): entry is readonly [string, number] => entry[1] !== undefined)));
                }
            });

        return () => {
            cancelled = true;
        };

    }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

    return amounts;
};